<template>
  <el-button type="warning" @click="open">Estorno
    <el-dialog title="Estorno de atendimentos" center width="80%" :visible.sync="dialog">
      <el-table :data="tableList" v-loading="loading">
        <el-table-column property="id" label="ID" width="80"></el-table-column>
        <el-table-column property="name" label="Nome"></el-table-column>
        <el-table-column property="phone" label="Telefone"></el-table-column>
        <el-table-column property="createdAt" label="Data" width="180"></el-table-column>
        <el-table-column property="value" label="Valor"></el-table-column>
        <el-table-column label="#">
          <template slot="header" slot-scope="scope">
            <el-input v-model="filter" size="mini" placeholder="Pesquisar" />
          </template>
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.authorization">Em autorização</el-tag>
            <el-tag type="info" v-else-if="scope.row.plp">Objetos com PLP gerada</el-tag>
            <el-button v-else size="mini" type="danger" @click="reversal(scope.$index, scope.row)">Estornar</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click.stop.prevent="dialog = false">OK</el-button>
      </span>
    </el-dialog>
  </el-button>
</template>

<script>
import { PdvService } from "@/services/pdv/pdv.services";
export default {
  name: "PdvCallReversal",
  computed: {
    tableData() {
      const vm = this;
      return vm.tableList.filter(
        (data) =>
          !vm.filter ||
          data.id.toLowerCase().includes(vm.filter.toLowerCase()) ||
          data.name.toLowerCase().includes(vm.filter.toLowerCase()) ||
          data.phone.toLowerCase().includes(vm.filter.toLowerCase())
      );
    }
  },
  methods: {
    open() {
      const vm = this;
      vm.dialog = true;
      vm.loading = true;
      PdvService.call()
        .then((response) => {
          vm.tableList = response;
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => vm.loading = false);
    },
    reversal(index, row) {
      const vm = this;
      this.$confirm(`Confirma o estorno do atendimento ${row.id}?`, 'Atendimento', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        PdvService.reversal(row.id)
          .then((response) => {
            this.$message({
              type: "success",
              duration: 5000,
              message: "Atendimento enviado para aprovação do estorno com sucesso!",
              offset: 45,
            });
            vm.tableList[index].authorization = true;
          })
          .catch((error) => {
            this.$message({ type: "error", duration: 5000, message: error });
          })
          .finally(() => vm.loading = false);
      }).catch(() => false)
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      filter: '',
      tableList: [],
    };
  },
}
</script>